import { render } from "./HostMenu.vue?vue&type=template&id=368659be&scoped=true"
import script from "./HostMenu.vue?vue&type=script&lang=js"
export * from "./HostMenu.vue?vue&type=script&lang=js"

import "./HostMenu.vue?vue&type=style&index=0&id=368659be&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368659be"]])

export default __exports__